<template>
  <div class="loader-wrap" :style="{ 'background-image': 'url(images/preview.jpg)' }">
    <div class="loader">
      <div class="content">
        <div v-if="+percentage !== 100"
             :key="'initial-loader-progress'"
             class="loader-button">Loading... {{ percentage }}%</div>
        <div v-else
             :key="'initial-loader-ready'"
             class="loader-button active" @click="$emit('close')">Enter</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Loader',

    props: {
      progress: { type: Object, default: () => {} }
    },

    computed: {
      percentage() {
        return this.progressDataIsSet() && +this.progress.total !== 0
          ? ((+this.progress.loaded / +this.progress.total) * 100).toFixed(0)
          : 0
      },

      loaded() {
        return this.progress.loaded
      },

      total() {
        return this.progress.total
      }
    },

    methods: {
      progressDataIsSet() {
        return this.progress && this.progress.hasOwnProperty('loaded') && this.progress.hasOwnProperty('total')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/styles/mixins";

  $progress-bar-height: 4px;

  .loader-wrap {
    font-size: 2em;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: center center no-repeat;
    background-size: cover;
    z-index: 2;

    .loader {
      padding: 15px 40px;
      border-radius: 25px;
      color: #f7f7f7;
      position: absolute;
      top: 10%;
      left: 50%;
      @include transform-translate(-50%, 0);
      width: auto;
      height: auto;

      .content {
        text-transform: uppercase;
        font-size: 1em;
        font-weight: 300;

        .loader-button {
          background-color: #9f9f9f;
          @include border-radius(4px);
          padding: 10px 20px;
          font-size: 16px;
          font-weight: 400;
          width: 170px;

          &.active {
            background-color: #ffc107;
            color: #444;
            cursor: pointer;
            @include transition(all .1s);

            &:hover {
              @include box-shadow(0 0 8px 4px rgba(255, 193, 7, .5));
            }
          }
        }
      }
    }
  }

  .align-left {
    float: left;
  }

  .align-right {
    float: right;
  }

  .text-center {
    text-align: center;
  }
</style>
